import url from 'url';
import moment from 'moment';
import { get, toLower } from 'lodash';

const apiHost = process.env.API_HOST || '';
const availabilityEndpoint = url.parse(`${apiHost}/api/3/professionallocation/timeslots`);

export const Actions = {
    FOUND_AVAILABILITY: '@@nextAvailability/FOUND_AVAILABILITY',
    START_SEARCH_NEXT_AVAILABILITY: '@@nextAvailability/START_SEARCH_NEXT_AVAILABILITY',
};

export const startSearchNextAvailability = () => ({
    type: Actions.START_SEARCH_NEXT_AVAILABILITY,
});

export const foundAvailability = availability => ({
    type: Actions.FOUND_AVAILABILITY,
    payload: { availability },
});

export function getNextAvailability(parameters) {
    return dispatch => {
        const requestUrl = getUrl(parameters);
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        dispatch(startSearchNextAvailability());

        return fetch(requestUrl, options)
            .then(r => r.json())
            .then(r => {
                const nextAvailabileTime = get(r, 'data.professional_locations[0].next_timeslot.start_time');

                if (nextAvailabileTime) {
                    dispatch(foundAvailability(nextAvailabileTime));
                }
            });
    };
}

function getUrl({
    directoryId,
    insuranceCarrier,
    insurancePlan,
    isNewPatient,
    locationId,
    procedureId,
    providerId,
    referrerType,
    widget,
}) {
    const today = moment().format('YYYY-MM-DD');

    const query = {
        apikey: '',
        availability_time_filter: '',
        carrier_id: insuranceCarrier,
        date: today,
        days_ahead: 1,
        directoryId,
        is_new_patient: isNewPatient,
        plan_id: insurancePlan,
        procedure_id: procedureId,
        professional_location_ids: `${providerId}_${locationId}`,
        widget: widget || toLower(referrerType) === 'widget',
    };

    return url.format({
        ...availabilityEndpoint,
        query,
    });
}
